import { useRef, useState } from "react";
import submit from "submit-form";
import useClickOutside from "../../../../../../hooks/useClickOutside";
import useMenuDropUp from "../../../../../../hooks/useMenuDropUp";
import ExerciseInsertMenuItems from "../../../../../../parts/menus/ExerciseInsertMenuItems";
import SvgIcon from "../../../../../../parts/SvgIcon";

const MenuOptionsEditing = ({
  exercise,
  dayString,
  athleteId,
  shown = false,
}) => {
  const [opened, setOpened] = useState(false);
  const detailsRef = useRef(null);
  // Opening another exercise's menu (or clicking anywhere else) closes this one.
  useClickOutside(detailsRef, () => setOpened(false), opened);
  const dropUp = useMenuDropUp(detailsRef, opened);
  const exerciseId = exercise?._id || false;

  return (
    <div
      className="more"
      style={{ display: shown && exerciseId ? "flex" : "none" }}
    >
      <input type="radio" name="more" id={`more-${exerciseId || dayString}`} />

      <details ref={detailsRef} role="list" open={opened}>
        <summary
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setOpened(!opened);
          }}
          onBlur={(e) => {
            // keyboard: tabbing away closes it, moving into its own list doesn't
            if (e.relatedTarget?.role === "listbox") return;
            e.preventDefault();
            setOpened(false);
          }}
          aria-haspopup="listbox"
          className="p-0! h-auto!"
        >
          <SvgIcon src="/img/new-icons/vuesax-linear-add-square.svg" />
        </summary>
        <ul
          role="listbox"
          className={`exercise-menu${opened ? " opened" : ""}${dropUp ? " drop-up" : ""}`}
          tabIndex="-1"
        >
          <ExerciseInsertMenuItems
            activeExercise={exercise}
            day={dayString}
            onSelect={() => setOpened(false)}
          />
          {!exercise.complex && (
            <li
              onClick={(e) => {
                e.stopPropagation();
                setOpened(false);
                submit(
                  `/actions/exercise/duplicate-from-single-day?proxyAthlete=${athleteId}`,
                  {
                    method: "POST",
                    body: exercise,
                  }
                );
              }}
            >
              <a>Duplicate</a>
            </li>
          )}
          <li
            onClick={(e) => {
              e.stopPropagation();
              setOpened(false);
              const body = {
                "modal[type]": "calendar-add-exercise",
                day: dayString,
                exercise: exercise._id,
                editMode: true,
              };
              // Complexes open in Edit Workout with the rest of the workout
              // (sc-47391); point it at a saved member of the complex.
              if (exercise.complex && exercise.exercises?.length) {
                body.exercise = exercise.exercises[0]._id;
              }
              if (exercise.primary === "metcon") {
                body.addType = "metcon";
              }
              submit("/actions/refresh?", {
                method: "GET",
                body,
              });
            }}
          >
            <a>Edit</a>
          </li>
          {!exercise.complex && exercise.primary !== "metcon" && (
            <li
              onClick={(e) => {
                e.stopPropagation();
                setOpened(false);
                submit("/actions/refresh?", {
                  method: "GET",
                  body: {
                    "modal[type]": "swap-exercise",
                    exercise: exercise._id,
                    editMode: true,
                  },
                });
              }}
            >
              <a>Swap</a>
            </li>
          )}
          <li role="separator" className="exercise-menu-sep" />
          <li
            className="exercise-menu-danger"
            onClick={(e) => {
              e.stopPropagation();
              setOpened(false);
              if (exercise.complex && exercise.exercises) {
                submit("/actions/complex/remove", {
                  method: "POST",
                  body: {
                    exercises: exercise.exercises,
                  },
                });
              } else {
                submit(`/actions/exercise/remove/${exercise._id}`, {
                  method: "GET",
                  body: {
                    proxyAthlete: athleteId,
                  },
                });
              }
            }}
          >
            <a>Delete</a>
          </li>
        </ul>
      </details>
    </div>
  );
};

export default MenuOptionsEditing;
